"use strict";

export const editorialStaffMixin = {
  mounted: function() {
    let lastKnownPosition = window.scrollY;
    let ticking = false;
    const _self = this;
    window.addEventListener("scroll", function() {
      lastKnownPosition = window.scrollY;
      if (!ticking) {
        window.requestAnimationFrame(function() {
          _self.showStickyName = lastKnownPosition > 250;
          ticking = false;
        });
      }
      ticking = true;
    });
    _self.showStickyName = lastKnownPosition > 250;
  },
  data: {
    showStickyName: false,
  },
};
